/**
 * Created by Jie Gao on 12/05/2020.
 */
import {HorribleHeroesReelSymbol} from "./HorribleHeroesReelSymbol";
import {ISymbolStateConfig, SymbolStateTransition} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TweenLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {HorribleHeroesGameConfig} from "../HorribleHeroesGameConfig";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";


export class HorribleHeroesSymbolM extends HorribleHeroesReelSymbol {
    protected static _symbolAnchorOffsetY: { [symName: string]: number } = {
        M1: 57,
        M2: 45,
        M3: 45,
        M4: 47,
        M5: 46,
        MX: 42,
    };
    protected static _symbolOffsetY: { [symName: string]: number } = {
        M1: 0,
        M2: 0,
        M3: 5,
        M4: 0,
        M5: 0,
        MX: 0
    };
    protected static _tintColor: { [symName: string]: number } = {
        M1: 0xff0000,
        M2: 0xffff00,
        M3: 0x8000ff,
        M4: 0x008d24,
        M5: 0x00baff,
        MX: 0xff0000
    };
    protected _symTop: PIXI.Sprite;
    protected _symBottom: PIXI.Sprite;
    protected _symLeft: PIXI.Sprite;
    protected _symRight: PIXI.Sprite;
    protected _symImage: PIXI.Sprite;
    private _multiplier: PIXI.Sprite;
    private _anchorY: number = 0.5;


    public patchMultiplier(multiplier: number): void {
        if (this.symName.length < 3) {
            return;
        }
        this._multiplier.y = 0;
        this._multiplier.texture = GameResources.getTextures(`X${multiplier}`)[0];
        this.addChild(this._multiplier);
        this._multiplier.position.set(0, this.symHeight / 2 - 42);
        this._multiplier.visible = true;
    }

    public updateFrame(symHeight: number): void {
        if (this._symTop) {
            this._symTop.y = -symHeight / 2 + this._symTop.height / 2 - 1;
            this._symBottom.y = symHeight / 2 - this._symBottom.height / 2 + 1;
        }
    }

    public updateBackground(symHeight: number): void {
        super.updateBackground(symHeight);
        if (this.symHeight > 147) {
            this._anchorY = 0.25;
        } else {
            this._anchorY = MathHelper.roundToDecimals(Math.min(Math.max(HorribleHeroesSymbolM._symbolAnchorOffsetY[this.symName], this.symHeight / 2), 73.5) / 294, 2);
        }

        for (let stateName in this._stateAnimations) {
            const state = this._stateAnimations[stateName];
            if (state != null) {
                state.anchor.y = this._anchorY;
                this._symImage.anchor.y = this._anchorY;
                this.fitToSize(state, symHeight);
            }
        }


    }

    public addWinFire(): void {
        super.addWinFire();
        this._winFireAnimation.tint = HorribleHeroesSymbolM._tintColor[this.getSymbolName(this.symName)];
    }

    public onRemove(): void {
        if (this._multiplier) {
            this.removeChild(this._multiplier);
        }
        if (this._symLeft) {
            this.removeChild(this._symLeft);
        }

        if (this._symRight) {
            this.removeChild(this._symRight);
        }

        if (this._symBottom) {
            this.removeChild(this._symBottom);
        }

        if (this._symTop) {
            this.removeChild(this._symTop);
        }

        super.onRemove();
    }

    /**
     * Animate Other symbols on reelWhile X expands
     * @param symbolH - height after expansion
     * @param symId -symbol which requires to be expanded
     * @param top - this symbol is above Stacked symbol
     */

    public adjustSize(symbolH: number, symId: number, duration: number = 0.17): TimelineLite | void {
        const tl = new TimelineLite();
        let symTop = -symbolH / 2 + this._symTop.height / 2 - 1;
        let symYPOs = ((symId) * symbolH) + (symbolH / 2);
        let symBottom = symbolH / 2 - this._symBottom.height / 2 + 1;
        let previousHeight = this.symHeight;
        let scaleY = symbolH / previousHeight;
        let symY = -(symbolH * 0.1);
        const startPos = 0;
        if (this._symTop) {
            top && tl.to(this._symTop, duration, {y: symTop}, startPos);
            tl.to(this._symBottom, duration, {y: symBottom}, startPos);
        }
        if (this._symMask) {
            tl.to(this._symMask.scale, duration, {y: scaleY}, startPos);
            tl.to(this._symImage, duration, {y: symY}, startPos);
        }
        tl.to(this, duration, {
            y: symYPOs
        }, startPos);
        return tl;
    }

    /**
     * Animate Stack symbols on reelWhile X expands
     * @param symbolH - height after expansion
     * @param symId -symbol which requires to be expanded
     * @param shiftY - from Original position of Symbol
     */
    public animateStackSymbol(symbolH: number, symId: number, shiftY: number): TimelineLite {
        //#347,#348,#349
        let previousHeight = this.symHeight;
        const topOffset = this._symTop.height / 2 - 1;
        const bottomOffset = this._symBottom.height / 2 + 1;
        const duration = 0.15;
        const mSize = Number(this.symName[3]);//M1_3*1
        let scaleY = (symbolH * mSize) / previousHeight;
        const charY = -(symbolH * mSize) / 4 - HorribleHeroesSymbolM._symbolOffsetY[this.symName.split("_")[0]];
        let tl = new TimelineLite();
        const starPos = 0;
        let symTop = -(symbolH) / 2 + topOffset;
        let symBottom = (symbolH) / 2 - bottomOffset;
        if (mSize === 3) {
            symTop = -1.5 * (symbolH) + topOffset;
            symBottom = 1.5 * (symbolH) - bottomOffset;
        } else {
            symTop = -(symbolH) + topOffset;
            symBottom = (symbolH) - bottomOffset;
        }
        tl.to(this, duration, {y: this.y - shiftY}, starPos);
        tl.to(this._symMask!.scale, duration, {y: scaleY}, starPos);
        tl.to(this._symTop!, duration, {y: symTop}, starPos);
        tl.to(this._symBottom!, duration, {y: symBottom}, starPos);
        tl.to(this._symImage!, duration, {y: charY}, starPos);
        return tl;
    }

    protected initAnimations(): void {
        super.initAnimations();
        this.name = this.symName;
        this._bg.texture = GameResources.getTextures("M" + this.symName[1] + "_bg")[0];
        this._bg.name = "M" + this.symName[1] + "_bg";

        if (!this._symRight) {
            this._symLeft = this.createEmptySprite("M_left");
            this._symRight = this.createEmptySprite("M_left");
            this._symRight.scale.x = -1;
            this._symLeft.x = -this.width / 2 + 5;
            this._symRight.x = this.width / 2 - 5;
        }

        if (!this._symTop) {
            this._symTop = this.createEmptySprite("M_top", 0);
            this._symTop.y = -this.symHeight / 2 + this._symTop.height / 2 - 1;
        }
        if (!this._symBottom) {
            this._symBottom = this.createEmptySprite("M_top", 1);
            this._symBottom.y = this.symHeight / 2 - this._symBottom.height / 2 + 1;
            this._symBottom.scale.y = -1;
        }
        if (!this._multiplier) {
            this._multiplier = this.createEmptySprite("");
            this._multiplier.scale.set(0.7);
            this._multiplier.visible = false;
        }
    }

    public drawSymMask(): void {
        this._symMask = new PIXI.Graphics();
        this._symMask.beginFill(0xFF0000, 1);
        this._symMask.drawRect(-GameConfig.instance.SYMBOL_WIDTH / 2, -this.symHeight / 2, GameConfig.instance.SYMBOL_WIDTH + 20, this.symHeight);
        this.addChild(this._symMask);
        this.mask = this._symMask;
        this._symMask!.name = "mask";
    }

    protected framesOnTopLayer(): void {
        this.addChild(this._symLeft);
        this.addChild(this._symRight);
        this.addChild(this._symTop);
        this.addChild(this._symBottom);
    }

    protected addNewStateAnimation(timeline: TimelineLite, newState: SymbolStateTransition, stateAnimation: TimelineSprite, delay: number): void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
        if (this._winFireAnimation) {
            this._winFireAnimation.hide();
            this._winFireAnimation.stopLoop();
        }
        if (newState.state.keyword === HorribleHeroesGameConfig.instance.SYMBOL_STATES.noWin.keyword) {
            this.dimOrGlowSymParts(0x777777);

        }
        if (newState.state.keyword === HorribleHeroesGameConfig.instance.SYMBOL_STATES.normal.keyword) {
            this.dimOrGlowSymParts(0xffffff);
            timeline.add(() => {
                this.toggleVisiblity(1, delay);
            }, delay);
        }
        if (newState.state.keyword === HorribleHeroesGameConfig.instance.SYMBOL_STATES.spin.keyword) {
            timeline.add(() => {
                this.toggleVisiblity(0, delay);
            }, delay)
        }
        if (newState.state.keyword === HorribleHeroesGameConfig.instance.SYMBOL_STATES.win.keyword) {
            this.dimOrGlowSymParts(0xffffff);
            if (!this._winFireAnimation) {
                this.addWinFire();
            }
            const scale: number = MathHelper.roundToDecimals(this.symHeight / 147, 2);
            this._winFireAnimation.scale.set(1, scale);
            this._winFireAnimation.tint = HorribleHeroesSymbolM._tintColor[this.getSymbolName(this.symName)];
            this.addChild(this._winFireAnimation);
            timeline.add([
                this._winFireAnimation.getAnimationAutoShowHide(true, true)
            ], delay);
            this.fitToSize(stateAnimation, this.symHeight);
        }
    }

    protected initState(stateConfig: ISymbolStateConfig): boolean {
        if (super.initState(stateConfig)) {
            if (this.symHeight > 147) {
                this._anchorY = 0.25
            } else {
                this._anchorY = MathHelper.roundToDecimals(Math.min(Math.max(HorribleHeroesSymbolM._symbolAnchorOffsetY[this.symName], this.symHeight / 2), 133) / 294, 2);
            }
            if (this._symLeft) {
                this.addChild(this._symLeft);
            }

            if (this._symRight) {
                this.addChild(this._symRight);
            }
            if (this._symBottom) {
                this.addChild(this._symBottom);
            }

            if (this._symTop) {
                this.addChild(this._symTop);
            }
            this._stateAnimations[stateConfig.keyword]!.anchor.y = this._anchorY;
            this._symImage.anchor.y = this._anchorY;
            if (this._multiplier) {
                this.addChild(this._multiplier);
            }
            if (this._winFireAnimation) {
                this.addChild(this._winFireAnimation);
            }
            if (this._symMask) {
                this.addChild(this._symMask);
                this.mask = this._symMask;
            }
            return true;
        }

        return false;
    }

    protected fitToSize(state: TimelineSprite, symHeight?: number) {
        if (!symHeight) {
            symHeight = this._symHeight!
        }
        if (this.symName.indexOf("*") > -1) {
            this._symImage.y = -symHeight / 4;
            if (this.symName[3] == "3" && symHeight > 222) {
                this._symImage.y = -symHeight / 4 - HorribleHeroesSymbolM._symbolOffsetY[this.symName.split("_")[0]];
            }
        } else {
            if (HorribleHeroesGameConfig.instance.HIGHMSYMS.indexOf(this.symName) > -1) {
                this._symImage.y = -(symHeight * 0.1);
                if (this._winFireAnimation) {
                    this._winFireAnimation.scale.set(0.95, (this.symHeight / 147) - 0.05);
                }
            } else {
                this._symImage.y = 0;
            }
        }

    }

    private getSymbolName(symbolName: string): string {
        //#374
        let symName: string = symbolName;
        if (this.symName.indexOf("*") > -1) {
            symName = this.symName.split("_")[0];
        }
        return symName;
    }

    private dimOrGlowSymParts(tint: number) {
        this._multiplier.tint = tint;
        this._symTop.tint = tint;
        this._symLeft.tint = tint;
        this._symBottom.tint = tint;
        this._symRight.tint = tint;
        this._bg.tint = tint;
        this._symImage.tint = tint;
    }

    private toggleVisiblity(alphaV: number, delay: number) {
        TweenLite.to(this._symTop, delay, {alpha: alphaV});
        TweenLite.to(this._symLeft, delay, {alpha: alphaV});
        TweenLite.to(this._symBottom, delay, {alpha: alphaV});
        TweenLite.to(this._symRight, delay, {alpha: alphaV});
    }


}